import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["pending", "success", "rejected", "retryLink"]

  connect() {
    this.poll()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  poll() {
    fetch(this.urlValue)
      .then(response => response.json())
      .then(data => {
        if (data.status === "active") {
          this.pendingTarget.hidden = true
          this.successTarget.hidden = false
        } else if (data.status === "rejected") {
          if (this.hasRetryLinkTarget && data.retry_url) {
            this.retryLinkTarget.href = data.retry_url
          }
          this.pendingTarget.hidden = true
          this.rejectedTarget.hidden = false
        } else if (data.status === "pending") {
          this.timer = setTimeout(() => this.poll(), 1000)
        }
        // status === "error" (expired/invalid token): stop polling, leave spinner
      })
      .catch(() => {
        this.timer = setTimeout(() => this.poll(), 1000)
      })
  }
}
